<div class="chips-container">
  <ng-content select="[prefix]" />
  <div class="label">
    {{ text }}
  </div>
  <div #suffixWrapper [class.with-suffix]="!!suffixWrapper.children.length" layout>
    <ng-content select="[suffix]" />
  </div>
  @if (showClose) {
    <rt-icon (click)="close.emit()" size="small-x" name="close" class="close" />
  }
</div>
